import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Scrolling Banner */}
        <div className="bg-red-600 text-white py-4 mb-12 overflow-hidden">
          <div className="whitespace-nowrap animate-scroll">
            <span className="inline-block px-8">
              📚 TRANSFORMAÇÃO ESPIRITUAL PROFUNDA ⚠️ JORNADA AO LADO DE JESUS ⚠️ 
              PROSPERIDADE ETERNA ⚠️ NARRATIVA DOS QUATRO EVANGELHOS ⚠️ 
              CRESCIMENTO ESPIRITUAL ⚠️ PROPÓSITO DE VIDA ⚠️ 
              TRANSFORMAÇÃO ESPIRITUAL PROFUNDA ⚠️ JORNADA AO LADO DE JESUS ⚠️
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-bold mb-4">Sobre o Livro</h3>
            <p className="text-gray-300 mb-4">
              "A Vida de Jesus: O Evangelho da Prosperidade Eterna" é uma jornada transformadora que harmoniza os quatro evangelhos em uma narrativa envolvente e profunda.
            </p>
            <p className="text-gray-300">
              Experimente caminhar ao lado de Jesus e descobrir a verdadeira prosperidade eterna.
            </p>
          </div>

          {/* Contact Section */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contato</h3>
            <div className="space-y-2">
              <p className="text-gray-300">📱 WhatsApp: (21) 98640-2130</p>
              <p className="text-gray-300">🌐 avidadejesus.bringhenti.com.br</p>
              <p className="text-gray-300">✉️ Disponível para dúvidas e orientações</p>
            </div>
          </div>

          {/* Purchase Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Onde Comprar</h3>
            <div className="space-y-2">
              <a 
                href="https://www.amazon.com.br/Vida-Jesus-Evangelho-Prosperidade-Eterna/dp/B0F28CR9RW" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-red-400 hover:text-red-300 transition-colors"
              >
                📚 Amazon (Físico)
              </a>
              <a 
                href="https://www.amazon.com.br/Vida-Jesus-Evangelho-Prosperidade-Eternidade-ebook/dp/B0FDC5L47T" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-red-400 hover:text-red-300 transition-colors"
              >
                📱 Amazon (Kindle)
              </a>
              <a 
                href="https://loja.uiclap.com/titulo/ua68103/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-red-400 hover:text-red-300 transition-colors"
              >
                📖 UICLAP
              </a>
            </div>
          </div>
        </div>

        {/* Security and Payment */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-gray-400 mb-2">© 2025 - Todos os direitos reservados.</p>
              <p className="text-gray-400">Marcio Bringhenti - A Vida de Jesus: O Evangelho da Prosperidade Eterna</p>
            </div>
            
            <div className="text-center">
              <p className="text-sm text-gray-400 mb-2">Site 100% seguro</p>
              <p className="text-sm text-gray-400">🔒 Conexão segura SSL</p>
            </div>
            
            <div className="text-center">
              <p className="text-sm text-gray-400 mb-2">Formas de Pagamento</p>
              <p className="text-sm text-gray-400">💳 Cartão | PIX | Boleto</p>
            </div>
          </div>

          <div className="mt-8 p-4 bg-gray-800 rounded-lg">
            <p className="text-sm text-gray-400 text-center">
              Este site não faz parte do site da AMAZON ou UICLAP. Além disso, este site NÃO é endossado por essas plataformas de forma alguma. 
              AMAZON e UICLAP são marcas comerciais de suas respectivas empresas.
            </p>
            <p className="text-sm text-gray-400 text-center mt-2">
              O livro "A Vida de Jesus: O Evangelho da Prosperidade Eterna" tem como objetivo ajudar pessoas a obterem transformação espiritual 
              através da jornada ao lado de Jesus Cristo. Nós não compartilharemos seu endereço de e-mail ou número de contato com ninguém.
            </p>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
        .animate-scroll {
          animation: scroll 20s linear infinite;
        }
      `}</style>
    </footer>
  );
};

export default Footer;